<!--
 * @Author: LiZhiWei
 * @Date: 2026-06-02 08:54:03
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-06-02 12:57:12
 * @Description: 
-->
<template>
  <section
    id="data"
    ref="dataSection"
    class="landing-container scroll-mt-70px h-583px bg-#0b2456 py-45px lt-sm:h-auto lt-sm:py-72px overflow-hidden bg-[url('/assets/img/figma/data-section-bg.png')] bg-cover bg-center text-white transition-all duration-1000 ease-out"
    :class="[isDataVisible ? 'translate-y-0 opacity-100' : 'translate-y-50px opacity-0']"
    data-section
  >
    <div
      class="h-493px w-1440px gap-20px lt-sm:left-auto lt-sm:h-auto lt-sm:w-full lt-sm:translate-x-0 lt-sm:grid-cols-1 lt-sm:gap-32px relative left-1/2 z-1 grid translate-x-[-50%] grid-cols-[876px_544px] items-center"
    >
      <div
        class="h-493px w-876px lt-sm:h-auto lt-sm:w-full lt-sm:min-h-430px relative"
        aria-label="数据决策中心示意"
      >
        <img
          class="h-538px w-921px lt-sm:relative lt-sm:mx-auto lt-sm:h-auto lt-sm:w-full lt-sm:max-w-[921px] lt-sm:translate-x-0 lt-sm:hover:translate-x-0 absolute top-0 left-0 max-w-none translate-x-[-28px] transition-all duration-280 hover:translate-x-[-28px] hover:translate-y-[-6px] hover:drop-shadow-[0_24px_22px_rgba(0,0,0,0.22)]"
          src="/assets/img/figma/data-dashboard.png"
          alt=""
          aria-hidden="true"
        />
      </div>

      <div class="w-544px lt-sm:w-full">
        <h2
          class="pf-sc-semibold mb-16px font-s-40px lt-sm:font-s-44px lt-sm:leading-[56px] m-0 leading-[1.25] text-white"
        >
          让经营决策有据可依
        </h2>
        <p
          class="pf-sc-regular max-w-610px font-s-18px lt-sm:font-s-22px lt-sm:leading-[34px] m-0 leading-[1.9] text-white/88"
        >
          将在管项目、房屋、住户、水电表、收费数据、动态事件、成本管理、设备管理、企业员工和异常指标统一可视化呈现。
        </p>
        <div class="mt-34px gap-14px lt-sm:grid lt-sm:grid-cols-2 flex flex-wrap">
          <span
            v-for="item in dataHighlights"
            :key="item"
            class="min-h-45px px-16px lt-sm:w-full lt-sm:justify-center inline-flex items-center rounded-full border border-white/28 bg-white/12 text-white/94"
          >
            {{ item }}
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  defineOptions({
    name: 'DataSection',
  })

  const dataSection = useTemplateRef<HTMLElement>('dataSection')
  const { isVisible: isDataVisible } = useScrollReveal(dataSection)

  const dataHighlights = ['多项目汇总', '异常指标预警', '收缴率分析', '设备状态监控']
</script>
